import { lazy, useState } from 'react'
import { useCoinAllQuery } from '@queries/common/coinAllQuery.js'
import { useOrgInfoStore } from '@store/common/useOrgInfoStore.js'
import SearchTabSection from '@sections/search/SearchTabSection.jsx'
import { useSearchTabStore } from '@store/search/useSearchTabStore.js'
import { useTranslation } from 'react-i18next'
const SearchInputResultSection = lazy(() => import('@sections/search/SearchInputResultSection.jsx'))

const SEARCH_COIN_ALL_STALE_TIME = 0

const SearchPage = () => {
  const { t } = useTranslation()
  const sections = useOrgInfoStore((s) => s.sections)
  const shouldUseAll = sections.includes('RANKING_ALL')
  const shouldUseExchange = sections.includes('RANKING_EXCHANGE')
  const shouldShowTabs = shouldUseAll && shouldUseExchange

  const tab = useSearchTabStore((s) => s.tab)
  const setSearchTab = useSearchTabStore((s) => s.setSearchTab)

  const TABS = [
    {
      label: t('search.tabs.all'),
      flag: 'all'
    },
    {
      label: t('search.tabs.exchange'),
      flag: 'exchange'
    }
  ]
  const [activeTab, setActiveTab] = useState(tab ?? 'all')
  const {
    data: searchData,
    isLoading,
    isError,
    error
  } = useCoinAllQuery({
    staleTime: SEARCH_COIN_ALL_STALE_TIME
  })

  if (isError && !searchData) throw error

  return (
    <section className={'flex flex-auto flex-col'}>
      <ul className={'flex w-full bg-white text-center'}>
        {shouldShowTabs && (
          <SearchTabSection
            tabs={TABS}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            setSearchTab={setSearchTab}
          />
        )}
      </ul>
      <SearchInputResultSection
        activeTab={activeTab}
        searchData={searchData}
        isSearchDataLoading={isLoading}
        shouldUseAll={shouldUseAll}
        shouldUseExchange={shouldUseExchange}
      />
    </section>
  )
}

export default SearchPage
